import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { hasPermission, surveyPartPermission } from 'unihow-common';
import SelectSurveyPartTypeDialog from '../SelectSurveyPartTypeDialog';
import { routes } from '../../../constants';

import styles from '../SurveySchemas.module.css';
import useTitle from '../../../hooks/useTitle';
import BrowseSurveyParts from '../BrowseSurveyParts';

const SurveyParts = ({ translate: t }) => {
  const permissions = useSelector((state) => state.user.currentUser.permissions);
  const isSurveySchemaPartsAdmin = hasPermission(permissions, surveyPartPermission(true));
  useTitle(`${t('surveySchemas.title')} - ${t('surveySchemaParts.schemaParts')}`);

  return (
    <section>
      <h2 className="panel__title">{t('surveySchemaParts.schemaParts')}</h2>
      <p>{t('surveySchemaParts.schemaPartsIntroduction')}</p>
      {isSurveySchemaPartsAdmin && (
      <div className={styles.actions}>
        <SelectSurveyPartTypeDialog
          confirmRoute={routes.surveySchemas.surveyParts.create.index}
          dataCy="create-schema-part-button"
          buttonText={t('surveySchemaParts.createNew')}
          labelText={t('selectSurveyPartTypeDialog.surveyPartLabel')}
        />
      </div>
      )}
      <BrowseSurveyParts />
    </section>
  );
};

const { func } = PropTypes;
SurveyParts.propTypes = {
  translate: func.isRequired
};

export default SurveyParts;
